<template>
  <div class="familyInfo">
    <info-form
      isFamily
      isEdit
      @submit-form="submitForm"
      :personId="id"
    ></info-form>
  </div>
</template>

<script>
import { setFamilyInfo } from "@/api/user.js";

export default {
  name: "familyInfo",
  data() {
    return {
      id: this.$route.query.id
    };
  },
  methods: {
    async submitForm(form) {
      const { code } = await setFamilyInfo(form);
      if (code === 0) {
        this.$toast({
          message: "保存成功",
          icon: require("@/assets/images/success.png")
        });
        this.$router.go("-1");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.familyInfo {
}
</style>
